/**
 * Routes that stay mounted while useAuth.isLoading is true. App otherwise
 * swaps the whole router for a full-page spinner, which unmounts the page that
 * started the login. On /auth that dropped handleGuestAccess mid-flight: its
 * navigate() then ran against the torn-down router, the hash changed, and the
 * remounted router kept showing the Sign in card until a reload (MOSA-545).
 */
const KEEP_ROUTER_WHILE_LOADING = new Set([
  "/guest",
  "/setup",
  "/auth",
  // MOSA-694: verifyEmail sets isLoading too. Without this the spinner
  // replaced the verify screen mid-call, and the confirmation that item 6
  // adds was lost with the unmounted component.
  "/auth/verify-email",
]);

export function keepsRouterWhileLoading(hash: string): boolean {
  const path = hash.replace(/^#/, "").split("?")[0].replace(/\/$/, "");
  return KEEP_ROUTER_WHILE_LOADING.has(path);
}
